export const AutomationActionTypeEnum = {
  add_case_control: 'add_case_control',
  remove_case_control: 'remove_case_control',
  set_assignee: 'set_assignee',
  mark_control_as_completed: 'mark_control_as_completed',
  mark_control_as_uncompleted: 'mark_control_as_uncompleted',
  add_tag: 'add_tag',
  create_aml_check: 'create_aml_check',
  create_company_monitoring_check: 'create_company_monitoring_check',
  create_document_check: 'create_document_check',
  create_electronic_signature_check: 'create_electronic_signature_check',
  create_id_document_check: 'create_id_document_check',
  create_id_verification_check: 'create_id_verification_check',
  log: 'log',
  set_template: 'set_template',
  reject_case: 'reject_case',
  approve_case: 'approve_case',
  reopen_case: 'reopen_case',
  lookup: 'lookup',
  exit: 'exit',
  set_risk: 'set_risk',
} as const;

export type AutomationActionTypeEnum =
  (typeof AutomationActionTypeEnum)[keyof typeof AutomationActionTypeEnum];
